module.exports = "\n<div class=\"panel simple\">\n  <div class=\"panel-title\">\n    <h3>Mailingi</h3>\n  </div>\n  <div class=\"panel-body\">\n    <data-table [columns]=\"columns\" [rows]=\"rows\" [buttons]=\"actions\" [isLoading]=\"isLoading\"\n                [pager]=\"pager\" (tableChanged)=\"tableChanged($event)\"></data-table>\n\n\t<mailing-modal #mailingModal (refreshList)=\"refreshList($event)\"></mailing-modal>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/mailings/mailings.component.html
// module id = ../../../../../src/app/main/mailings/mailings.component.html
// module chunks = 1